import React from 'react';
export function ProgressBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-[hsl(var(--foreground))]/40 bg-[hsl(var(--background))]/90 px-4 py-3 backdrop-blur-md" data-id="element-93">
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-1.5" data-id="element-94">
        <div className="flex items-center justify-between font-mono text-[11px] font-medium uppercase tracking-[0.12em]" data-id="element-95">
          <span className="text-[hsl(var(--foreground))]" data-id="element-96">
            Form Completion Index: 2% (Certified)
          </span>
          <span className="hidden text-[hsl(var(--muted-foreground))] normal-case tracking-normal sm:inline" data-id="element-97">
            Recalculated hourly by committee.
          </span>
        </div>
        <div className="h-1 w-full overflow-hidden border border-[hsl(var(--foreground))]/30 bg-[hsl(var(--card))]" data-id="element-98">
          <div className="h-full w-[2%] bg-[hsl(var(--foreground))]" data-id="element-99" />
        </div>
      </div>
    </div>;
}